module.exports = __webpack_public_path__ + "media/assets/good_at/docker-7ad5d6e0dd59dc59d905c1cfff3e0fde.png";